import { PATH_CONTEST_AGREEMENTS, PATH_ROOT } from "@/constants";
import type { BreadcrumbItem } from "@/types/breadcrumb";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface UseContestAgreementDetailBreadcrumbsProps {
  label: string;
}

export const useContestAgreementDetailBreadcrumbs = ({
  label,
}: UseContestAgreementDetailBreadcrumbsProps): BreadcrumbItem[] => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      { label: t("breadcrumb.home"), href: PATH_ROOT },
      {
        label: t("contestAgreements.title.multiple"),
        href: PATH_CONTEST_AGREEMENTS,
      },
      {
        label,
      },
    ],
    [t, label],
  );
};
